import {observable, action, runInAction, computed, autorun} from "mobx";
import appstate from "../appstate";

class AddonStore {

    @observable cache: CC.Library.Models.Addons.AddonsResponse[];
    @observable isLoading: boolean;
    @observable warningMessages: string[];
    @observable addonStoreMessage: string;
    
    private xhrRefs: XMLHttpRequest[];

    constructor () {
        this.cache = [];
        for (let i=0; NCB.Settings.HotelProperties.MaxReservationsPerItinerary > i; i++) {
            this.cache.push(null);
        }

        this.isLoading = false;
        this.xhrRefs = [];
        this.warningMessages = [];
        this.addonStoreMessage = "";
    }

    @action
    clearMessage = () => {
        this.addonStoreMessage = "";
    }

    @action
    addInclusiveAddonsToCart = (roomIndex: number) => {
        let addonsInCart = appstate.reservations[roomIndex].Services.map(a => a.ServiceCode);
        let inclusiveAddons = this.cache[roomIndex].Addons.filter(a => a.Inclusive)
            .filter(a =>  addonsInCart.indexOf(a.Code) === -1)
            .filter(a => {
                let f = NCB.FeatureMatrix.getAddonFeature(a.Code);

                // NHRSUPPORT-1216 - feature decides if addon should be added automatically
                if (f.PreselectInclusiveAddon === false)
                    return false;

                // Filter out any addons that are grouped
                return f.AddonGroupId == null || f.AddonGroupId.length === 0
            });
        
        inclusiveAddons.forEach(a => {
            let addonDay = a.AddonDates[0];
            let addonTime = addonDay.AddonTimes[0];
            appstate.addService(roomIndex, {
                Date: addonDay.DateData,
                Guests: [{
                    Count: addonTime.Quantity,
                    GuestType: CC.Library.Models.Shared.GuestType.Adult,
                    Age: null
                }],
                ServiceCode: a.Code,
                StartTime: addonTime.TimeData
            }, 0);
        });
    }

    @action
    removeRoom = (roomIndex: number) => {
        this.cache.splice(roomIndex, 1);
    }

    @action
    loadAddons = (roomIndex: number, startDate: Date, endDate: Date, rateCode: string, roomCode: string, promotionCode: string, guests: CC.Library.Models.Shared.NcbGuestCount[]) => {
        if (rateCode == null)
            return;

        if (roomCode == null)
            return;

        if (this.xhrRefs[roomIndex] != null)
            this.xhrRefs[roomIndex].abort();

        this.isLoading = true;
        // this.cache[roomIndex] = null;
        
        let handler: NCB.Addons.IAddonsResponse = {
            success: (res: CC.Library.Models.Addons.AddonsResponse) => {

                if (res.Addons == null)
                    res.Addons = [];
                
                NCB.Addons.filterAddons(res, guests, roomCode);
                
                NCB.Addons.sortAddons(res);

                runInAction(() => {
                    this.cache[roomIndex] = res;

                    this.addInclusiveAddonsToCart(roomIndex);

                    let message = appstate.checkCartIntegrity(roomIndex);
                    if (message != null) {
                        this.addonStoreMessage = message;
                    }
                    this.isLoading = false;
                });

                /*
                console.group("addonStore.loadAddons()");
                console.log(roomIndex, startDate, endDate, roomCode, rateCode, guests, promotionCode);
                console.table(res.Addons.map(x => { 
                    return {
                        code: x.Code,
                        title: x.Title
                    }
                 }));
                console.groupEnd(); */
            },
            error: (error: NCB.Proxy.ICompoundError) => {
                NCB.Log.customError("Error loading addons ", error);
                runInAction(() => {
                    this.cache[roomIndex] = {
                        StartDate: NCB.DateUtils.getISODate(startDate),
                        EndDate: NCB.DateUtils.getISODate(endDate),
                        Addons: [],
                        Success: true
                    };
                });
                this.isLoading = false;
            }
        }

        // Build request
        let req = NCB.Addons.generateDefaultRequest();
        req.StartDate = NCB.DateUtils.getISODate(startDate);
        req.EndDate = NCB.DateUtils.getISODate(endDate);
        req.RatePlanOrGroupCode = rateCode;
        // req.RatePlanFilterCode = rateCode;
        req.RoomTypeCode = roomCode;
        req.PromotionCode = promotionCode;
        req.Guests = guests;
        req.PreheldInventoryId = (appstate != null) ? appstate.modifyConfirmationNumber : "";    

        this.xhrRefs[roomIndex] = NCB.Addons.getAddons(handler, req);
    }
}

const addonstore = new AddonStore();

export default addonstore;


// WEBPACK FOOTER //
// ./src/stores/addonStore.ts